const locale = {
	pageTitle: 'Contact Us | QingYi Precision',
	pageDesc: 'Contact QingYi Precision for Swiss-type CNC machining quotes. Cincom L20, φ1–20mm small-diameter parts, ±0.005mm tolerance, ISO 9001 certified. Phone: +886-966-686-161.',
	pageKeywords: 'QingYi Precision contact, CNC machining quote, Cincom L20 quote, precision machining inquiry, Swiss-type lathe machining, CNC machining contact, New Taipei precision machining',
	title: 'Contact Us',
	subtitle: 'Fill in the form below and we will get back to you as soon as possible',
	name: 'Company / Name',
	namePlaceholder: 'QingYi Precision',
	phone: 'Phone',
	phonePlaceholder: '+886-2-8687-2058',
	email: 'Email',
	emailPlaceholder: 'example@company.com',
	content: 'Message',
	contentPlaceholder: 'Please describe your requirements, e.g. material, quantity, machining specs...',
	file: 'Attachment',
	selectFile: 'Choose File',
	send: 'Send Inquiry',
	errorName: 'Please enter your company name or contact name',
	errorContact: 'Please provide a phone number or email address',
	errorEmail: 'Please enter a valid email address',
	mapTitle: 'Our Location'
};

export default locale;
